import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { updateUserPreference } from '../../../redux/user/user.actions';
import { get, debounce, getConfig } from '../../../helpers';
import Bookmark from './bookmark';

const debounceDuration = getConfig('components.bookmarkThrottleDuration');

let allBookmarks: BookmarkParams[] = [];

const debounceFunc = debounce(dispatch => {
    const localBookmarkQueue = Object.create(allBookmarks);
    dispatch(updateUserPreference.action(localBookmarkQueue)).then(allBookmarks = allBookmarks.filter(el => {
        return localBookmarkQueue.indexOf(el) < 0;
    }));
}, debounceDuration);

const mapStateToProps = (state: RootStoreState, ownProps: BookmarkProps): BookmarkProps & BookmarkContainerProps => {
    const { keyId, bookmarkType } = ownProps;
    const bookmarkPreference = get(state.user, 'bookmarkPreference', { bookMarks: { datasets: [], solutions: [], queries: [], blueprints: [] } });
    const { bookMarks } = bookmarkPreference;

    let isBookmarked = false;
    if (bookMarks) {
        if (bookmarkType === 'solutions') {
            isBookmarked = bookMarks.solutions && bookMarks.solutions.some(x => x.keyId === keyId);
        } else if (bookmarkType === 'blueprints') {
            isBookmarked = bookMarks.blueprints && bookMarks.blueprints.some(x => x.keyId === keyId);
        } else if (bookmarkType === 'queries') {
            isBookmarked = bookMarks.queries && bookMarks.queries.some(x => x.keyId.toString() === keyId.toString());
        } else {
            isBookmarked = bookMarks.datasets && bookMarks.datasets.some(x => x.keyId.toString() === keyId.toString());
        }
    }

    return { ...ownProps, isDataBookmarked: isBookmarked };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<{ isLoggedIn: boolean }, {}, AnyAction>): BookmarkActions => ({
    updateUserPreference: async (params: BookmarkParams) => {
        allBookmarks.push(params);
        debounceFunc(dispatch);
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(Bookmark);
